





















import Vue from 'vue'
import { PRODUCT_INFO } from '@@/graphQL/web'

const createDummyProduct = () => ({
  __typename: 'Product',
  id: 63,
  name: 'product 1',
  article: 'product-1',
  description: null,
  brand: null,
  labels: [],
  offers: [{
    __typename: 'Offer',
    id: 76,
    name: 'product 1',
    properties: [],
    images: [''],
    price: 140,
    quantity: 20
  }],
  url: 'https://api.alissa.simla.shop/catalog/details/63-product-1',
  slug: '63-product-1',
  quantity: 20,
  stock: false
})

export default Vue.extend({
  name: 'BlockProduct',

  components: {
    FullscreenGallery: () => import('./BlockProduct/FullscreenGallery.vue'),
    ProductCard: () => import('./BlockProduct/ProductCard.vue')
  },

  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },

    isMock: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    product: null,
    mockSlug: 'random-product'
  }),

  async fetch () {
    try {
      const { data } = await this.$apolloProvider.defaultClient.query({
        query: PRODUCT_INFO,
        variables: {
          siteCode: this.$store.state.siteCode,
          slug: this.isMock ? this.mockSlug : this.$route.params.slug
        }
      })

      if (data.productBySlug) {
        this.product = data.productBySlug
      } else {
        this.$nuxt.error({ statusCode: 404 })
      }
    } catch (e) {
      console.log(e)
      // временное решение, если товара в каталоге нет
      if (this.$store.state.admin && this.product === null) {
        // @ts-ignore
        this.product = createDummyProduct()
      } else {
        this.$nuxt.error({ statusCode: 404 })
      }
    }
  }
})
